module.exports = __webpack_public_path__ + "img/3.d7d5e39e.png";